export const policyActions = [
    { label: "Bank charge", id: "write-off" },
    { label: "Refund", id: "refund" },
    // { label: "Correction Reasons", id: "correction-types" },
    // { label: "Corrective Transfer", id: "corrective-transfer" },
    // { label: "Cross Allocation", id: "cross-allocation" },
    // { label: "CFI", id: "cfi" },
    // { label: "Treasury Update", id: "tresury-update" },
    // { label: "MSD Update", id: "msd-update" },
  ];